export const links = {
  youtube: 'https://www.youtube.com/planoprever',
  facebook: 'http://www.facebook.com/preveronline',
  linkedin: 'https://www.linkedin.com/company/grupo-prever/',
  instagram: 'https://instagram.com/planoprever',
  assistancesManual: 'www.planoprever.com.br/manual',
};

export const footerLinks = [
  {
    label: 'NOSSAS UNIDADES',
    href: 'https://www.planoprever.com.br/unidades',
  },
  {
    label: 'CONTATO',
    href: 'https://www.planoprever.com.br/contato',
  },
  {
    label: 'POLÍTICA DE PRIVACIDADE',
    href: 'https://www.planoprever.com.br/politica-privacidade',
  },
];

export const email = 'relacionamento@grupopreversul.com.br';

export const company =
  'Prever Angelus Administradora LTDA CNPJ:33.149.334/0001-80';

export const tenant = 'prever_pr';

export const state = 'Paraná';

export const slug = 'pr';

export const product = 'Prever Angelus Paraná';

export const brand = 'Prever Angelus';

export const plansLabel = 'Planos Prever Angelus';

export const description =
  'Plano Prever Angelus é referência em assistência familiar no Sul do Brasil. ';

export const coverage = 'Assistência funeral com cobertura nacional';
